import React from 'react';
import { AlertTriangle, Info, Bell } from 'lucide-react';
export type AlertPriority = 'critical' | 'warning' | 'info';
interface AlertItemProps {
  title: string;
  description: string;
  time: string;
  priority: AlertPriority;
  productName?: string;
  onClick?: () => void;
}
export function AlertItem({
  title,
  description,
  time,
  priority,
  productName,
  onClick
}: AlertItemProps) {
  const styles = {
    critical: {
      border: 'border-l-red-500',
      icon: AlertTriangle,
      iconColor: 'text-red-500',
      bg: 'hover:bg-red-50'
    },
    warning: {
      border: 'border-l-amber-500',
      icon: Bell,
      iconColor: 'text-amber-500',
      bg: 'hover:bg-amber-50'
    },
    info: {
      border: 'border-l-emerald-500',
      icon: Info,
      iconColor: 'text-emerald-500',
      bg: 'hover:bg-emerald-50'
    }
  };
  const config = styles[priority];
  const Icon = config.icon;
  return <div onClick={onClick} className={`bg-white p-4 rounded-md shadow-sm border-l-4 ${config.border} ${config.bg} transition-colors cursor-pointer mb-3`} data-id="element-15">
      <div className="flex items-start justify-between" data-id="element-16">
        <div className="flex items-start space-x-3" data-id="element-17">
          <Icon className={`h-5 w-5 mt-0.5 ${config.iconColor}`} data-id="element-18" />
          <div data-id="element-19">
            <h4 className="text-sm font-semibold text-navy-900" data-id="element-20">{title}</h4>
            <p className="text-sm text-slate-600 mt-1" data-id="element-21">{description}</p>
            {productName && <p className="text-xs font-medium text-navy-700 mt-2 bg-slate-100 inline-block px-2 py-1 rounded" data-id="element-22">
                Produto: {productName}
              </p>}
          </div>
        </div>
        <span className="text-xs text-slate-400 whitespace-nowrap" data-id="element-23">{time}</span>
      </div>
    </div>;
}